module.exports = __webpack_public_path__ + "img/05b35a5.png";